import { useNode } from "@craftjs/core";
import React, { useContext, useState } from "react";
import { TableSettings } from "./settings";
import GrigoraCSSRenderer from "./../css-render";
import classNames from "classnames";
import { RichTextInput } from "../../input";
import { CMSTableSettings } from "./cms-settings";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import CMSIcon from "./cms-icon";
import { INPUT_LIMITS } from "../../input-limits";
import { GrigoraDashboardContext } from "../../dashboard/context";

export const Table = (props) => {
  const [row, setRows] = useState(2);
  const [col, setCols] = useState(2);

  const {
    id,
    connectors: { connect, drag },
    actions: { setProp },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const { screen } = useContext(GrigoraDashboardContext) ?? {};

  const { tableHeader, tableFooter, table = [], equalColumnsWidth } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-table": true,
      [`table-${id}`]: id,
    },
    blockProps.className,
  );

  function createTable() {
    setProp((props) => {
      props.table = [...Array(row)].map((e) => Array(col).fill(""));
    });
  }

  return (
    <div
      {...blockProps}
      {...(screen === "cms-post-editor"
        ? { ref: (ref) => connect(ref) }
        : { ref: (ref) => connect(drag(ref)) })}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__Table(id, props)}`}</style>
      {!(table && table.length > 0) ? (
        <div className="empty-table">
          <div className="empty-table__title">Table</div>
          <div className="empty-table__desc">
            Enter the number of Rows and Columns of table.
          </div>
          <div className="empty-table__select">
            <label>Rows</label>
            <div className="box">
              <input
                value={row}
                onChange={(e) => {
                  if (e.target.value > 100) {
                    e.target.value = 100;
                  }
                  setRows(Number(e.target.value));
                }}
                type="number"
                min={INPUT_LIMITS["table-rows"].minlength}
                max={INPUT_LIMITS["table-rows"].maxlength}
                maxLength={3}
              />
            </div>
            <span className="mx-4">X</span>
            <label>Columns</label>
            <div className="box">
              <input
                value={col}
                onChange={(e) => {
                  if (e.target.value > 15) {
                    e.target.value = 15;
                  }
                  setCols(Number(e.target.value));
                }}
                type="number"
                min={INPUT_LIMITS["table-cols"].minlength}
                max={INPUT_LIMITS["table-cols"].maxlength}
                maxLength={2}
              />
            </div>
            <button onClick={createTable}>OK</button>
          </div>
        </div>
      ) : (
        <>
          <table className={`${equalColumnsWidth && "table-fixed"}`}>
            {tableHeader && tableHeader.length > 0 && (
              <thead>
                <tr>
                  {tableHeader.map((item, i) => {
                    return (
                      <th key={`table-${id}-header-${i}`}>
                        <RichTextInput
                          value={item ?? ""}
                          onChange={(e) => {
                            setProp((props) => {
                              var temp = [
                                ...(props.tableHeader ? props.tableHeader : []),
                              ];
                              temp[i] = e;
                              props.tableHeader = temp;
                              return props;
                            }, 500);
                          }}
                          tagName={"p"}
                        />
                      </th>
                    );
                  })}
                </tr>
              </thead>
            )}
            <tbody>
              {table.map((row, i) => {
                return (
                  <tr key={`table-${id}-${i}`}>
                    {row.map((col, j) => {
                      return (
                        <td key={`table-${id}-${i}-${j}`}>
                          <RichTextInput
                            key={`table-rt-${id}-${i}-${j}`}
                            value={table[i][j]}
                            onChange={(e) => {
                              setProp((props) => {
                                // var temp = [
                                //   ...(props.table ? props.table : [[""]]),
                                // ];

                                // for (var k = 0; k < props.table.length; k++)
                                //   temp[k] = props.table[k].slice();

                                // temp[i][j] = e;
                                // props.table = temp;
                                props.table[i][j] = e;
                                return props;
                              }, 300);
                            }}
                            tagName={"p"}
                          />
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
            {tableFooter && tableFooter.length > 0 && (
              <tfoot>
                <tr>
                  {tableFooter.map((item, i) => {
                    return (
                      <td key={`table-${id}-footer-${i}`}>
                        <RichTextInput
                          value={item}
                          onChange={(e) => {
                            setProp((props) => {
                              var temp = [
                                ...(props.tableFooter ? props.tableFooter : []),
                              ];
                              temp[i] = e;
                              props.tableFooter = temp;
                              return props;
                            }, 500);
                          }}
                          tagName={"p"}
                        />
                      </td>
                    );
                  })}
                </tr>
              </tfoot>
            )}
          </table>
        </>
      )}
    </div>
  );
};

// To Avoid Mangling in Production
Table.displayName = "Table";

Table.craft = {
  name: "Table",
  props: {},
  related: {
    settings: TableSettings,
    CMSsettings: CMSTableSettings,
    icon: icon,
    CMSIcon: CMSIcon,
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    category: "basic",
    keywords: ["Table", "Excel", "Spreadsheets"],
  },
  custom: {
    name: "Table",
    slug: "grigora/table",
  },
  rules: {
    canMoveIn: (incomingNodes) =>
      incomingNodes.every((incomingNode) => incomingNode.data.type === Table),

    canMoveOut: (outgoingNodes) =>
      outgoingNodes.every((outgoingNodes) => outgoingNodes.data.type !== Table),
  },
};
